import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSyncLogsComponent } from './data-sync-logs.component';
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {CalendarModule} from "primeng/calendar";
import {MultiSelectModule} from "primeng/multiselect";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputTextareaModule} from "primeng/inputtextarea";
import {SidebarModule} from "primeng/sidebar";
import {DropdownModule} from "primeng/dropdown";
import {ToastModule} from "primeng/toast";
import {TabViewModule} from "primeng/tabview";



@NgModule({
  declarations: [DataSyncLogsComponent],
    imports: [
        CommonModule,
        ButtonModule,
        RippleModule,
        CalendarModule,
        MultiSelectModule,
        FormsModule,
        InputTextareaModule,
        SidebarModule,
        DropdownModule,
        ToastModule,
        ReactiveFormsModule,
        TabViewModule
    ]
})
export class DataSyncLogsModule { }
